import { render, staticRenderFns } from "./ptjs.vue?vue&type=template&id=2a0589b8&scoped=true&"
import script from "./ptjs.vue?vue&type=script&lang=js&"
export * from "./ptjs.vue?vue&type=script&lang=js&"
import style0 from "./ptjs.vue?vue&type=style&index=0&id=2a0589b8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a0589b8",
  null
  
)

export default component.exports